import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';

import Spinner from '../components/Spinner';
import AlertDialog from '../components/utils/AlertDialog';
import OrderReopenDialog from '../components/OrderReopenDialog';
import { isLockedOrder } from '../utils/adManagerHelpers';
import { isReadOnly } from '../utils/readOnly';
import PlacementPage from '../components/placement/PlacementPage';
import {
  setError,
  setEditList,
  setPlacement,
  saveAndNotify,
  goToPlacement,
  resetClonePlacementState,
  deletePlacement,
  cancelPlacement,
} from '../actions/placementActions';
import { getOrder } from '../actions/orderActions';
import { reopenProposal } from '../actions/reopenActions';
import { getConstants } from '../actions/constantActions';
import { getStrategies, getSalesProducts } from "../actions/strategyActions";
import { getDeviceTypes } from "../actions/deviceTypesActions";
import { getCreativeProducts } from "../actions/creativeProductActions";
import { getPresets, getTPTs } from "../actions/presetActions";
import { countLineItems } from "../utils/countLineItems";

export class Placement extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dfpViewOpen: false,
      showReopenModal: false,
      itemRemainder: 0,
      itemLimit: 0,
      dialog: {
        open: false,
        title: '',
        message: ''
      },
      packageId: (props.placement && props.placement.packageId) ? props.placement.packageId : props.location.search.slice(5)
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {
      dispatch,
      match,
      order,
      constants,
      strategies,
      deviceTypes,
      salesProducts,
      creativeProducts,
      presets,
      tpts,
    } = this.props;
    toast.dismiss();
    let id = parseInt(match.params.pid, 10);
    if (Number.isNaN(id)) {
      id = null;
    }
    const orderId = match.params.id;
    if (isEmpty(constants)) {
      dispatch(getConstants());
    }
    if (!isEmpty(order)) {
      if (id) {
        this.setPlacement(id);
        this.setBatch(id);
      }
      this.setLineItemCount();
    } else {
      dispatch(getOrder(orderId)).then(() => {
        if (this.props.error) {
          return;
        }
        if (id) {
          this.setPlacement(id);
          this.setBatch(id);
        }
        this.setLineItemCount();
      });
    }
    if (isEmpty(strategies)) {
      dispatch(getStrategies());
    }
    if (isEmpty(salesProducts)) {
      dispatch(getSalesProducts());
    }
    if (isEmpty(deviceTypes)) {
      dispatch(getDeviceTypes());
    }
    if (isEmpty(creativeProducts)) {
      dispatch(getCreativeProducts());
    }
    if (isEmpty(presets)) {
      dispatch(getPresets());
    }
    if (isEmpty(tpts)) {
      dispatch(getTPTs());
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname.includes('refresh') || nextProps.location.pathname.includes('refresh')) {
      if (nextProps.location.pathname !== this.props.location.pathname) {
        alert(this.props.location.pathname);
      } else {
        if (this.props.location.pathname.slice(-8) === '/refresh') {
          const newUrl = this.props.location.pathname.slice(0, -8) + this.props.location.search;
          this.props.history.push(newUrl);
        }
      }
    }
  }

  pageLoaded = initial => {
    const { dispatch, placement } = this.props;
    if (isEmpty(placement) && !this.props.location.pathname.includes('create')) {
      dispatch(setPlacement(initial));
    }
  };

  setLineItemCount = () => {
    const { itemRemainder, itemLimit } = countLineItems(this.props.order);
    this.setState({ itemRemainder, itemLimit });
  };

  setPlacement = id => {
    const { dispatch, order } = this.props;
    const placements = order.Placements || [];
    const placement = placements.find(p => p.id === id) || {};
    if (!!id && isEmpty(placement)) {
      dispatch(setError({ status: 404, message: 'Not Found' }));
      document.title = `Placement - GALILEO`;
      return;
    }
    document.title = `Placement ${placement.agencyPlacementName} - GALILEO`;
    if (placement.packageId) {
      this.setState({ packageId: placement.packageId});
    }
    dispatch(setPlacement(placement));
  };

  // in order to move to the next and previous placement
  setBatch = (id) => {
    const { editList, dispatch, order } = this.props;
    if (isEmpty(editList)) {
      if (order && order.Placements) {
        const list = order.Placements.map(p => p.id);
        dispatch(setEditList(list));
        const idx = list.indexOf(parseInt(id, 10));
        dispatch(goToPlacement(idx));
      } else {
        dispatch(goToPlacement(0));
      }
    } else {
      const idx = editList.indexOf(parseInt(id, 10));
      dispatch(goToPlacement(idx));
    }
  };

  redirectToParent = () => {
    const { order, history } = this.props;
    const { packageId } = this.state;
    if (!packageId) {
      history.push(`/ios/${order.id}`);
    } else {
      history.push(`/ios/${order.id}/package/${packageId}/refresh`);
    }
  };

  /**
   * If necessary, stash placement and sideEffect and plan to render modal.
   */
  savePlacement = (placement, sideEffect) => {
    const { order, dispatch } = this.props;
    placement.legend = 'placement screen';
    placement.totalContractedAmount = placement.totalContractAmount;
    if (isLockedOrder(order) && this.checkIfModal(placement)) {
      this.setState({ modalStash: { placement, sideEffect } });
      return;
    }
    toast.dismiss();
    dispatch(saveAndNotify(placement)).then(() => {
      sideEffect();
    })
  };

  checkIfModal = (p) => {
    const changeList = (!isEmpty(p.priorValues)) ? this.findChanges(p, p.priorValues) : [];
    if (!isEmpty(changeList)) {
      this.setState({
        showReopenModal: true,
        changeList: changeList
      });
      return true;
    }
    return false;
  };

  findChanges = (newP, oldP) => {
    const changeList = [];
    if (newP.start !== oldP.start) {
      changeList.push('Start Date');
    }
    if (newP.end !== oldP.end) {
      changeList.push('End Date');
    }
    if (newP.ioRate !== oldP.ioRate) {
      changeList.push('IO Rate');
    }
    if (newP.ioRateTypeId !== oldP.ioRateTypeId) {
      changeList.push('IO Rate Type');
    }
    if (newP.contractedQuantity !== oldP.contractedQuantity) {
      changeList.push('Contracted Quantity');
    }
    if (oldP.CreativeProductIds !== newP.CreativeProducts.map(cp => cp.id)) {
      changeList.push('Creatives');
    }
    return changeList;
  };

  handleModalClose = (reopenStatus) => {
    const { dispatch, order } = this.props;
    const { modalStash } = this.state;
    if (reopenStatus === 'Reopen') {
      order.dfpReopenStatus = 'Reopened';
      dispatch(saveAndNotify(modalStash.placement)).then(() => {
        modalStash.sideEffect();
      }).then(() => {
        dispatch(reopenProposal(order.id));
      });
    } else {
      this.setState({ showReopenModal: false });
    }
  };

  nextPlacement = () => {
    const { currentPlacement, editList } = this.props;
    const index = currentPlacement + 1;
    this.setPlacement(editList[index]);
    this.moveToPlacement(index);
  };

  priorPlacement = () => {
    const { currentPlacement, editList } = this.props;
    const index = currentPlacement - 1;
    this.setPlacement(editList[index]);
    this.moveToPlacement(index);
  };

  newPlacement = () => {
    const { order, history, location } = this.props;
    const pkgId = location.search.slice(5);
      if (pkgId) {
        history.push(`/ios/${order.id}/placement/create/refresh?pkg=${pkgId}`);
      } else {
        history.push(`/ios/${order.id}/placement/create/refresh`);
      }
  };

  doneEditingBatch = () => {
    this.redirectToParent();
  };

  moveToPlacement = idx => {
    const {
      order,
      dispatch,
      history,
      editList
    } = this.props;
    dispatch(goToPlacement(idx));
    history.push(`/ios/${order.id}/placement/${editList[idx]}`);
  };

  toggleDfpView = () => {
    this.setState(prevState => ({ dfpViewOpen: !prevState.dfpViewOpen }));
  };

  cancel = () => {
    const { dispatch, history, placement } = this.props;
    dispatch(cancelPlacement(placement.id)).then(() => {
      history.push(`/ios/${placement.IoId}`);
    });
  };

  delete = () => {
    const dialog = {};
    dialog.open = true;
    dialog.title = 'Delete placement';
    dialog.onCancel = this.closeDialog;
    dialog.message = `Are you sure you want to delete this placement?`;
    dialog.onOk = this.confirmDelete;
    dialog.okTitle = 'Delete';
    dialog.okColor = "secondary";
    dialog.cancelTitle = 'Cancel Placement';
    this.setState({ dialog });
  };

  confirmDelete = () => {
    const { dispatch, history, placement } = this.props;
    this.closeDialog();
    dispatch(deletePlacement(placement.id)).then(() => {
      history.push(`/ios/${placement.IoId}`);
    });
  };

  closeDialog = () => {
    this.setState({
      dialog: {
        open: false,
        title: '',
        message: '',
        onCancel: null,
        onOk: null,
        cancelTitle: '',
        okTitle: '',
        okColor: ''
      }
    })
  };

  clone = () => {
    const { history, placement, dispatch } = this.props;
    if (!placement || !placement.id) {
      const message = 'placement or placement id do not exist, cannot clone';
      toast.error(message, { theme: 'colored', toastId: message });
      return;
    }
    dispatch(resetClonePlacementState());
    return history.push(`/ios/${placement.IoId}/placement/${placement.id}/clone`)
  };

  copySettings = () => {
    const { placement, history } = this.props;
    history.push(`/ios/${placement.IoId}/placement/${placement.id}/copysettings`);
  };

  validationError = errors => {
    const list = Object.keys(errors).join(', ')
      .replace('CustomCriteriaPresets', 'Targeting Details')
      .replace('Pubs', 'Publishers');
    const message = `These placementfields have errors: ${list}`;
    toast.error(message, { theme: 'colored', toastId: message });
  };

  render() {
    const {
      order,
      match,
      user,
      isFetching,
      placement,
      editList,
      constants,
      currentPlacement,
      strategies,
      deviceTypes,
      salesProducts,
      creativeProducts,
      presets,
      tpts,
      ...rest
    } = this.props;
    const { dialog, showReopenModal, itemRemainder, packageId } = this.state;
    const orderId = parseInt(match.params.id, 10);
    const fetching = isFetching;

    return (
      <div>
        {fetching && <Spinner />}
        {!fetching && showReopenModal && (
        <div>
          <OrderReopenDialog
            changeList={this.state.changeList}
            open
            onClose={this.handleModalClose}
          />
        </div>
        )}
        {!fetching && (
        <div>
          <AlertDialog {...dialog} />

          <PlacementPage
            ioId={orderId}
            order={order}
            placement={placement}
            user={user}
            constants={constants}
            strategies={strategies}
            deviceTypes={deviceTypes}
            salesProducts={salesProducts}
            creativeProducts={creativeProducts}
            presets={presets}
            tpts={tpts}
            editList={editList}
            currentPlacement={currentPlacement}
            onLoad={this.pageLoaded}
            onBack={this.redirectToParent}
            onClone={this.clone}
            onDelete={this.delete}
            onCancel={this.cancel}
            onSave={this.savePlacement}
            onNext={this.nextPlacement}
            onPrior={this.priorPlacement}
            onNew={this.newPlacement}
            onDone={this.doneEditingBatch}
            onDfpView={this.toggleDfpView}
            onCopySettings={this.copySettings}
            onValidationError={this.validationError}
            itemRemainder={itemRemainder}
            packageId={packageId}
            isReadOnly={isReadOnly({ role: user.roleName })}
            {...rest}
          />
        </div>
        )}
      </div>
    )
  }
}

Placement.defaultProps = {
  placement: null,
  order: null
};

Placement.propTypes = {
  placement: PropTypes.object,
  order: PropTypes.object
};

const mapStateToProps = state => {
  const {
    orderRequest,
    placementRequest,
    ccpRequest,
    tptRequest,
    strategyRequest,
    deviceTypesRequest,
    salesProductsRequest,
    creativeProductsRequest,
    constantRequest,
    selectedPlacements,
    user
  } = state;
  return {
    order: orderRequest.order,
    error: placementRequest.error || orderRequest.error,
    constants: constantRequest.constants,
    user,
    editList: selectedPlacements.editList,
    currentPlacement: selectedPlacements.current,
    placement: placementRequest.placement,
    strategies: strategyRequest.strategies,
    deviceTypes: deviceTypesRequest.deviceTypes,
    salesProducts: salesProductsRequest.salesProducts,
    creativeProducts: creativeProductsRequest.creativeproducts,
    presets: ccpRequest.ccp,
    tpts: tptRequest.tpt,
    isFetching: placementRequest.isFetching ||
      orderRequest.isFetching ||
      ccpRequest.isFetching ||
      salesProductsRequest.isFetching ||
      strategyRequest.isFetching ||
      deviceTypesRequest.isFetching ||
      creativeProductsRequest.isFetching ||
      tptRequest.isFetching
  }
};

export default connect(mapStateToProps)(Placement);
